import styles from "./Section10.module.scss";

export const Section10 = function ({ scrollTo }) {
  return (
    <section id="next_bootcamp" className={`${styles.container} cc--component-container`}>
      <div className={styles.content}>
        <div className={styles.copy}>
          <span className={`${styles.headline} title`}>
            The Next Cybersecurity Boot Camp Starts November 13, 2024. Reserve Your Spot Today!
          </span>
          <span className={styles.subHeadline}>
            It only takes a minute to request information and be put in touch with a member of the admissions team who
            can answer questions and get your application started.
          </span>
        </div>
        <div className={styles.cta}>
          <a onClick={scrollTo} className={`${styles.button} wp-block-button__link`} href="#form">
            Request Information to get started
          </a>
        </div>
      </div>
    </section>
  );
};
